import {useFieldArray, useFormContext} from 'react-hook-form';
import {Button} from '@common-web/components/ui/button';
import {Separator} from '@common-web/components/ui/separator';
import {ContactFields} from '../components/ContactFields';

export function ClientPortalAccessForm() {
  const {control} = useFormContext();
  const basePath = 'clientPortalAccessForm.users';
  const {fields, append, remove} = useFieldArray({control, name: basePath});

  return (
    <div className='space-y-6'>
      <div className='space-y-2'>
        <div className='font-semibold'>Client Portal Access Users</div>
        <p className='text-sm text-muted-foreground'>
          Add the people who should have access to the client portal.
        </p>
      </div>
      <div className='space-y-4'>
        {fields.length === 0 && (
          <div className='text-sm text-muted-foreground'>No users added yet.</div>
        )}
        {fields.map((field, index) => {
          const userPath = `${basePath}.${index}`;
          return (
            <div key={field.id} className='border rounded-lg p-4 space-y-4'>
              <ContactFields basePath={userPath} titlePrefix={`User ${index + 1}`} />
              <div className='flex justify-end'>
                <Button type='button' variant='outline' onClick={() => remove(index)}>
                  Remove User
                </Button>
              </div>
            </div>
          );
        })}
        <div className='flex justify-start'>
          <Button
            type='button'
            onClick={() =>
              append({
                firstName: '',
                lastName: '',
                title: '',
                phone: '',
                email: '',
              })
            }
          >
            Add User
          </Button>
        </div>
        <Separator />
      </div>
    </div>
  );
}
